import {ItemData, PointKey} from "./item_types";

export function repeatString(str: string, times: number): string {
  let result = "";
  for (let i = 0; i < times; i += 1) {
    result += str;
  }
  return result;
}

export function replace(result: ItemData, x: number, y: number, character: string): void {
  const value = {v: character};
  const key: PointKey = [x, y];
  result.points.forEach((point, i) => {
    if (point[0][0] === x && point[0][1] === y) {
      result.points[i] = [key, value];
    }
  });
  result.index[x + "_" + y] = value;
}

export function add(result: ItemData, x: number, y: number, character: string): void {
  const value = {v: character};
  const key: PointKey = [x, y];
  result.points.push([key, value]);
  result.index[x + "_" + y] = value;
}

export function concat(result: ItemData, other: ItemData): void {
  result.points = result.points.concat(other.points);
  result.index = {...result.index, ...other.index};
}



// WEBPACK FOOTER //
// ./assets/js/item_utils.ts


// WEBPACK FOOTER //
// ./assets/js/item_utils.ts